module.exports = __webpack_public_path__ + "static/media/sunIcon.668e4f6a.svg";